import styled from '@emotion/styled'
import { FC } from 'react'
import { Pagination as PaginationBase, PaginationProps } from '@mui/material'
import { Colors } from 'src/components/theme'

const SPagination = styled(PaginationBase)<{ alternativestyle?: number }>`
  .MuiPaginationItem-root {
    ${({ shape }) => shape === 'rounded' && 'border-radius: 8px !important;'}

  .MuiButtonBase-root {
    ${({ alternativestyle }) =>
      alternativestyle &&
      `
      background-color: white;
      border: 1px solid ${Colors.neutral100};

      &:hover {
        opacity: 0.8;
      }
    `}
  }

  .Mui-selected {
    background-color: ${Colors.blueDark} !important;
    color: white !important;

    &:hover {
      background-color: ${Colors.blueDark} !important;
      opacity: 0.8 !important;
    }
  }
`

type Props = PaginationProps & {
  alternativestyle?: boolean
}

export const Pagination: FC<Props> = ({ alternativestyle, ...props }) => {
  return <SPagination {...props} alternativestyle={alternativestyle ? 1 : 0} />
}
